import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicSiteHeader from './PublicSiteHeader';
import PublicSiteFooter from './PublicSiteFooter';
import { GlowButton } from './LandingPrimitives';
import { trackLandingEvent } from './analytics';

const DEFAULT_META = {
  title: 'Ground Aale | Smart Ground Management Platform',
  description: 'Ground Aale helps sports ground owners eliminate booking chaos, staff confusion, and revenue leaks.',
  ogDescription: 'Live for ground owners. Play. Book. Manage.',
};

export const useLandingMeta = ({ title, description, ogDescription } = {}) => {
  useEffect(() => {
    const meta = { ...DEFAULT_META, title, description, ogDescription };

    document.title = meta.title;

    const upsertMeta = (key, value, content) => {
      let tag = document.querySelector(`meta[${key}="${value}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(key, value);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    upsertMeta('name', 'description', meta.description);
    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.ogDescription || meta.description);
    upsertMeta('property', 'og:type', 'website');
  }, [title, description, ogDescription]);
};

const LandingLayout = ({ children }) => {
  const isAuthenticated = Boolean(localStorage.getItem('auth_token'));

  return (
    <div className="ga-bg min-h-screen text-ga-text-primary">
      <PublicSiteHeader>
        {isAuthenticated ? (
          <Link
            to="/dashboard"
            className="text-sm text-ga-text-muted transition hover:text-ga-text-primary"
            onClick={() => trackLandingEvent('header_open_dashboard_click')}
          >
            Open Dashboard
          </Link>
        ) : (
          <Link
            to="/login"
            className="text-sm text-ga-text-muted transition hover:text-ga-text-primary"
            onClick={() => trackLandingEvent('header_login_click')}
          >
            Login
          </Link>
        )}
        <GlowButton
          as={Link}
          to="/login"
          className="px-4 py-2 text-xs md:text-sm"
          onClick={() => trackLandingEvent('header_get_started_click')}
        >
          Get started
        </GlowButton>
      </PublicSiteHeader>

      <main>{children}</main>

      <PublicSiteFooter />
    </div>
  );
};

export default LandingLayout;
